export default function Field({ id, label, error, required = false, children }) {
  return (
    <div>
      <label htmlFor={id} className="mb-2 block font-mono2 text-[11px] uppercase tracking-[0.2em] text-slate-400">
        {label}
        {required && <span className="text-gold"> *</span>}
      </label>
      {children}
      {error && (
        <p data-testid={`error-${id}`} className="mt-1.5 text-xs text-red-400">
          {error}
        </p>
      )}
    </div>
  );
}
